import copy from 'copy-to-clipboard';
import {
  CREATE_BROADCAST,
  UPDATE_BROADCAST,
  DUPLICATE_BROADCAST
} from 'actions/Types';

import { BROADCAST_FORM } from 'constants/ModalTypes';

import { clearModal, showNotification } from 'actions';

import { getCurrentFSObjectChildren } from 'actions/Event';

import { withCurrentParams } from './utils';

export const createBroadcast = broadcastPayload => {
  return withCurrentParams((dispatch, { teamId, eventId, folderId }) => {
    const action = {
      type: CREATE_BROADCAST,
      request: async apiClient => {
        const payload = {
          broadcast: broadcastPayload,
          parentFolderId: folderId
        };

        const broadcast = await apiClient.broadcast.create(
          teamId,
          eventId,
          payload
        );
        dispatch(clearModal(BROADCAST_FORM));
        dispatch(getCurrentFSObjectChildren());

        return broadcast;
      }
    };

    dispatch(action);
  });
};

export const updateBroadcast = (broadcastId, broadcastPayload) => {
  return withCurrentParams((dispatch, { teamId, eventId }) => {
    const action = {
      type: UPDATE_BROADCAST,
      request: async apiClient => {
        const broadcast = await apiClient.broadcast.update(
          teamId,
          eventId,
          broadcastId,
          broadcastPayload
        );
        dispatch(clearModal(BROADCAST_FORM));
        dispatch(getCurrentFSObjectChildren());
        return broadcast;
      }
    };
    dispatch(action);
  });
};

/**
 * Copy broadcast/studio guest invite link
 */
export const copyInviteLink = broadcastId => {
  return withCurrentParams((dispatch, { teamId, eventId }) => {
    const location = window.location;
    const baseUrl = `${location.protocol}//${location.host}`;
    const inviteLink = `${baseUrl}/studio-presenter/teams/${teamId}/events/${eventId}/broadcasts/${broadcastId}/join`;

    copy(inviteLink);
    return dispatch(showNotification('Successfully copied guest invite link'));
  });
};

export const duplicateBroadcast = (broadcastId, parentId) => {
  return withCurrentParams((dispatch, { teamId, eventId }) => {
    const action = {
      type: DUPLICATE_BROADCAST,
      request: async apiClient => {
        const payload = {
          parentId
        };
        const broadcast = await apiClient.broadcast.duplicate(
          teamId,
          eventId,
          broadcastId,
          payload
        );

        dispatch(getCurrentFSObjectChildren());
        return broadcast;
      }
    };
    dispatch(action);
  });
};
